<template>
  <div class="dive-deeper">
   <vs-divider class="pb-0 mb-0"/>
    <vs-collapse>
      <vs-collapse-item >
          <div slot="header"><SidebarTitle icon="Maximize2Icon" title="dive deeper"/></div>
          <div class="cursor-default">
            <slot></slot>
          </div>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>
<script>

export default {
  components: {

  },
}
</script>


<style lang="scss">
.dive-deeper {
  .vs-collapse-item--header {
    padding-bottom: 0px !important;
    margin-bottom: 0px !important;
  }

  .con-content--item {
    padding-top: 0px !important;
    margin-top: 0px !important;
  }
}
</style>
